import { observer } from "mobx-react-lite";
import { Button, Message, Table } from "semantic-ui-react";
import {
  convertTicketTypeToString,
} from "../../app/common/util/functions";
import { useStore } from "../../app/stores/store";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MyPaging from "../../app/common/form/MyPaging";
import { PagingParams } from "../../app/models/pagination";

export default observer(function PartTicketSearch() {
  const { t } = useTranslation(["common", "inventory"]);
  const navigate = useNavigate();

  const { inventoryIndexStore, ticketStore } = useStore();

  const { resetTicketHistoryRegistry } = ticketStore;
  const {
    loadingTickets,
    loadExpandedInventoryIndexItemTickets,
    getExpandedInventoryIndexItemTickets,
    expandedTicketsPagination,
    expandedTicketsPagingParams,
    setExpandedTicketsPagingParams,
    expandedInventoryIndexItem,
    resetExpandedTicketsRegistry
  } = inventoryIndexStore;

  function listOnClick(value: number) {
    if (value > 0 && expandedTicketsPagination && value < expandedTicketsPagination?.totalPages + 1) {
      setExpandedTicketsPagingParams(new PagingParams(value));
      resetExpandedTicketsRegistry();
      loadExpandedInventoryIndexItemTickets(expandedInventoryIndexItem?.partId ?? "");
    }
  }
  
  return (
    <Table.Cell className="tableInTable textAlignRightNotMobile" colSpan={7}>
      <Table striped unstackable className="dnxTable no_padding">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {t("labels.invoiceNumber", { ns: "inventory" })}
            </Table.HeaderCell>
            <Table.HeaderCell>{t("date", { ns: "common" })}</Table.HeaderCell>
            <Table.HeaderCell>
              {t("labels.customerInformation", { ns: "inventory" })}
            </Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {getExpandedInventoryIndexItemTickets && getExpandedInventoryIndexItemTickets.length && !loadingTickets ?
            getExpandedInventoryIndexItemTickets.map(ticket => (
              <Table.Row key={ticket.ticketId}>
                <Table.Cell 
                  className='hoveredLink'
                  data-label={`${t("labels.invoiceNumber", { ns: "inventory" })}:`}
                  onClick={() => window.open(`/ticket/view/${ticket.ticketId}`, `_`)}
                >
                 {convertTicketTypeToString(ticket.ticketType)}{" "} #{ticket.ticketNumber}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("date", { ns: "common" })}:`}
                >
                  {ticket.date ? format(new Date(ticket.date), 'P') : null}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("labels.customerInformation", { ns: "inventory" })}:`}
                >
                  {ticket.customerInformation}
                </Table.Cell>
                <Table.Cell className="textAlignRight" width={5}>
                  <Button
                    content={t("View Ticket", { ns: "common" })}
                    icon="eye"
                    color="blue"
                    size="small"
                    onClick={() => {
                      resetTicketHistoryRegistry();
                      navigate(`/ticket/view/${ticket.ticketId}`);
                    }}
                  />
                </Table.Cell>
              </Table.Row>
            ))
            : (
              <Table.Row key={"noItems"}>
                <Table.Cell width="5" colSpan={5} className="noPaddingLeft">
                  <Message
                    color="yellow"
                    className="textAlignCenter fontStyleItalic"
                  >
                    {t("grid_noItems", { ns: "common" })}
                  </Message>
                </Table.Cell>
              </Table.Row>
            )}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan="6">
              <MyPaging
                itemCount={expandedTicketsPagination ? expandedTicketsPagination.totalItems : 10}
                pageSize={expandedTicketsPagingParams.pageSize}
                currentPage={expandedTicketsPagination ? expandedTicketsPagination.currentPage : 1}
                onClick={listOnClick}
                onChange={listOnClick}
                floated="right"
              ></MyPaging>
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Table.Cell>
  );
});
